import styled from 'styled-components';
import { tokens, palette, colors } from '@plataforma/components';

export const Container = styled.div`
  display: flex;
  width: 864px;
  height: 184px;
  background: #f9fbfd;
  border-radius: 4px;
  justify-content: space-between;
`;

export const Details = styled.div`
  padding-left: 49px;
  padding-right: 22px;
  padding-top: 29px;
  padding-bottom: 29px;
`;

export const Tag = styled.span`
  background-color: ${palette.primaryLight};
  color: ${colors.electricViolet};
  padding: 2px 4px;
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  letter-spacing: 0;
  display: inline-block;
  border-radius: 4px;
  font-weight: ${tokens.font.weight.semibold};
  margin-bottom: 4px;
`;

export const Description = styled.h1`
  font-size: 26px;
  line-height: 34px;
  font-weight: 600;
  letter-spacing: 0;
  color: ${colors.darkBlue};
  font-weight: ${tokens.font.weight.semibold};
  margin-bottom: 8px;

  span {
    color: ${colors.electricViolet};
  }
`;

export const Button = styled.div`
  color: ${colors.electricViolet};
  font-weight: ${tokens.font.weight.semibold};
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: start;
  cursor: pointer;
  width: 127px;

  svg {
    margin-right: 8px;
  }
`;

export const BannerImage = styled.div`
  width: 190px;

  img {
    width: 190px !important;
    max-width: 190px !important;
  }
`;
